let lockCount = 0;
let previousOverflow = '';
let previousPaddingRight = '';

export const lockBodyScroll = () => {
  lockCount += 1;

  if (lockCount > 1) {
    return;
  }

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  previousOverflow = document.body.style.overflow;
  previousPaddingRight = document.body.style.paddingRight;

  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }

  document.body.style.overflow = 'hidden';
};

export const unlockBodyScroll = () => {
  lockCount = Math.max(0, lockCount - 1);

  if (lockCount > 0) {
    return;
  }

  document.body.style.overflow = previousOverflow;
  document.body.style.paddingRight = previousPaddingRight;
};
